import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingAccountSummary } from './types';

export function useBillingAccounts() {
  const { data, error, isLoading, mutate } = useSWR<TBillingAccountSummary[]>(
    'commenda-billing/mirror/accounts',
    SWRFetcher({ method: 'GET' })
  );

  return { accounts: data ?? [], error, isLoading, mutate };
}
